import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tramites-estudiantiles',
  templateUrl: './tramites-estudiantiles.component.html',
  styleUrls: ['./tramites-estudiantiles.component.scss'],
  providers: [DatePipe]
})

export class TramitesEstudiantilesComponent implements OnInit {

  tituloPantalla = "TRÁMITES ESTUDIANTILES";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
